module.exports = __webpack_public_path__ + "assets/imgs/gmp/cm.9f9b6e1f0b90e743ca72187167b886d2.svg";